module.exports = __webpack_public_path__ + "static/media/studio 3 side shot ambience art decoration scene vibe.1280x1707.6e7a20c8.webp";